import React from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { store } from './helpers';

import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import App from './App';

// Import the i18n configuration
import './helpers/i18n';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
